import { BASIC_PLAN, SUBSCRIBER_PLAN } from "../../client/dashboard/pricingPlans";
import { formatEuro } from "../../client/dashboard/pricingCalculator";

export function getFreeTierVolumeBands(t) {
  return [
    { range: t("billing.band1"), pricePerReview: 129 },
    { range: t("billing.band2"), pricePerReview: 89 },
    { range: t("billing.band3"), pricePerReview: 79 },
  ];
}

export function getFreeTierFeatures(t) {
  return [
    { included: true, text: t("billing.oneLocation") },
    { included: true, text: t("billing.freeFeature1") },
    { included: false, text: t("billing.freeFeature2") },
    { included: false, text: t("billing.freeFeature3") },
  ];
}

export function getSubscriberFeatures(t) {
  return [
    t("billing.proFeature1"),
    t("billing.oneLocation"),
    t("billing.proFeature2"),
    t("billing.proFeature3"),
    t("billing.proFeature4"),
    t("billing.proFeature5"),
    t("billing.proFeature6"),
    t("billing.proFeature7"),
    t("billing.proFeature8"),
    t("billing.proFeature9"),
  ];
}

export function getEnterpriseFeatures(t) {
  return [
    t("billing.entFeature1"),
    t("billing.entFeature2"),
    t("billing.entFeature3"),
    t("billing.entFeature4"),
  ];
}

export function getPlanComparisonRows(t) {
  return [
    {
      feature: t("billing.featureLocations"),
      freeTier: t("billing.oneLocationShort"),
      professional: t("billing.oneLocationShort"),
      enterprise: t("billing.unlimitedLocations"),
      professionalHighlight: false,
    },
    {
      feature: t("billing.featureBillingModel"),
      freeTier: t("billing.freeBilling"),
      professional: t("billing.proBilling"),
      enterprise: t("billing.entBilling"),
      professionalHighlight: true,
    },
    {
      feature: t("billing.featureReviewSelection"),
      freeTier: t("billing.freeSelection"),
      professional: t("billing.proSelection"),
      enterprise: t("billing.entSelection"),
      professionalHighlight: true,
    },
    {
      feature: t("billing.featureIncludedDeletions"),
      freeTier: t("billing.freeIncluded"),
      freeTierMuted: true,
      professional: t("billing.proIncluded"),
      professionalBold: true,
      enterprise: t("billing.entIncluded"),
    },
    {
      feature: t("billing.featurePricePerReview"),
      freeTier: t("billing.freePrice"),
      professional: t("billing.proPrice"),
      enterprise: t("billing.entPrice"),
      professionalHighlight: true,
    },
    {
      feature: t("billing.featureSupportLevel"),
      freeTier: t("billing.freeSupport"),
      professional: t("billing.proSupport"),
      enterprise: t("billing.entSupport"),
    },
    {
      feature: t("billing.featureReporting"),
      freeTier: t("billing.freeReporting"),
      professional: t("billing.proReporting"),
      enterprise: t("billing.entReporting"),
      professionalHighlight: true,
    },
  ];
}

export { BASIC_PLAN, SUBSCRIBER_PLAN, formatEuro };
